import { render, staticRenderFns } from "./SimboloCategoria.vue?vue&type=template&id=13f3fdc4&scoped=true"
import script from "./SimboloCategoria.vue?vue&type=script&lang=js"
export * from "./SimboloCategoria.vue?vue&type=script&lang=js"
import style0 from "./SimboloCategoria.vue?vue&type=style&index=0&id=13f3fdc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f3fdc4",
  null
  
)

export default component.exports